export default __webpack_public_path__ + "static/media/Group1288.4e86dccd.png";